import { useEffect, useState } from "react";
import { Select } from "@chakra-ui/react";

import { useApiClient } from "../../shared/hooks";

interface IBloggedPlaces {
  id:string,
  name:string,
  created_at:string,
  updated_at:string
}

interface Props {
  onChange?: (selectedValue: string) => void;
}

function BloggedPlaces({ onChange }: Props) {
  const apiClient = useApiClient();
  const [bloggedPlaces, setBloggedPlaces] = useState<IBloggedPlaces[]>([]);
  const [bloggedID, setBloggedID] = useState<string>("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiClient.getBlogCategories("prod");
        setBloggedPlaces(response.data as any);
      } catch (error) {
        console.log(error, "Error during Fetch blogged places");
      }
    };
    fetchData();
  }, []);

  const handleBloggedIDChange = (selectedValue: string) => {
    onChange && onChange(selectedValue);
    setBloggedID(selectedValue);
  };

  return (
      <Select
        placeholder="All Post"
        width={"60"}
        onChange={(e) => handleBloggedIDChange(e.target.value)}
      >
        {bloggedPlaces.map((element) => (
          <option key={element.id} value={element.id}>
            {element.name.charAt(0).toUpperCase() + element.name.slice(1)}
          </option>
        ))}
      </Select>
  );
}

export default BloggedPlaces;
